import { Player } from '@cartwhl/3d/player';

import {
  cartographerFbxCharacterMeshLoader,
  createFbxCharacterMeshTransform,
} from '../../shared/cartographerFbxCharacterMesh';
import { PLAYER_ID, PLAYER_INITIAL_SETTINGS } from '../constants';
import MotionEditor from './MotionEditor';

export default function MotionEditorWithPlayer() {
  return (
    <Player.Root
      id={PLAYER_ID}
      initialSettings={PLAYER_INITIAL_SETTINGS}
      characterMesh={{
        loadFBX: cartographerFbxCharacterMeshLoader,
        createTransformLoadedMesh: (meshPath) =>
          createFbxCharacterMeshTransform({ meshPath }),
      }}
    >
      <MotionEditor />
    </Player.Root>
  );
}
